import * as React from 'react';

const PagePlaceholder = () => {
  return <div style={{ height: '100vh' }} />;
};

export default PagePlaceholder;
